const languages = {
  en_US: 'en_US',
  fr_FR: 'fr_FR',
};

export default languages;
